export const LOCAL_STORAGE_USER_ID = 'eledo-user-2.0';
//TODO: in the future, change this to a service dependent on the target platform
export const BASE_URL = process.env.REACT_APP_ELEDO_BASE_URL;
export const API_URL = BASE_URL + "/api/RESTv1";